import type { TOC } from '@ember/component/template-only';
import { concat } from '@ember/helper';
import t from 'ember-intl/helpers/t';
import type { Signature as ProviderSig } from 'parog-web/components/forc/provider';

const pancreaticMutations = [
  'brca1',
  'brca2',
  'palb2',
  'kras',
  'atm',
  'fanc-c',
  'prss1',
  'p16/cdkn2a',
  'lkb1/stk11',
  'mlh1',
  'msh2',
  'msh6',
  'pms2'
];

export default <template>
  {{!     Pancreatic cancer type     }}
  <div class='field'>
    <@form.BasicRadioGroup
      @title='Type du cancer'
      @propertyName='pancreaticCancerType'
      as |Group|
    >
      <div class='fields inline'>
        <div class='field'>
          <Group.Radio @label='Adénocarcinome' @value='adenocarcinoma' />
        </div>
        <div class='field'>
          <Group.Radio @label='Ampullome' @value='ampullome' />
        </div>
        <div class='field'>
          <Group.Radio
            @label='Tumeur neuro endrocrine'
            @value='neuroendocrineTumour'
          />
        </div>
        <div class='field'>
          <Group.Radio @label='Tumeur kystique' @value='cysticTumour' />
        </div>
      </div>
    </@form.BasicRadioGroup>
  </div>

  {{!     Mutation Génétique    }}

  <div class='field'>
    <@form.Dropdown
      @labelName='Mutation génétique'
      @propertyName='pancreaticMutation'
      @multipleSelection={{true}}
      as |dropdown|
    >
      {{#each pancreaticMutations as |pancreaticMutation|}}
        <dropdown.Item
          @key={{pancreaticMutation}}
          @value={{t
            (concat
              'fur.cancer-medical-history.pancreatic-mutations.'
              pancreaticMutation
            )
          }}
        />
      {{/each}}
    </@form.Dropdown>
  </div>
</template> satisfies TOC<{
  Args: {
    form: ProviderSig['Blocks']['content'][0];
  };
}>;
